import React, { useEffect, useState } from 'react';
import "./PlaceOrder.css";
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { addDoc, collection, getDoc, doc, updateDoc, deleteDoc, getDocs, onSnapshot } from "@firebase/firestore";
import Toast from 'react-bootstrap/esm/Toast';
import { Link } from 'react-router-dom';
import { Button, Tooltip, message } from "antd";
import { InfoCircleTwoTone } from "@ant-design/icons"
import Geocode from "react-geocode";

function PlaceOrder ( props ) {
    let [ show, setShow ] = useState( false );
    let [ show2, setShow2 ] = useState( false );
    let [ orderObject, setOrderObject ] = useState( {
        deliveryType: "Regular",
        deliveryHours: "48-72 hrs",
        expressDeliveryCharge: 0,
        day: new Date().getHours() < 18 ? "Today" : "Tomorrow",
        tip: ""
    } );
    const [ messageApi, contextHolder ] = message.useMessage();
    let [ total, setTotal ] = useState( 0 );
    let [ currentUser, setCurrentUser ] = useState( {} );

    async function onload ( user ) {
        let cartDocs = await getDocs( collection( firestore, "users/" + user.uid + "/cart_items/all_orders_id/all_orders" ) );
        let totalRaw = 0;
        cartDocs.forEach( ( element ) => {
            totalRaw += element.data().count * parseFloat( element.data().price );
        } )
        if ( totalRaw < 250 ) {
            orderObject.deliveryCharge = 50;
            setTotal( parseFloat( totalRaw ) + 50 );
        } else {
            orderObject.deliveryCharge = 0;
            setTotal( parseFloat( totalRaw ) );
        }

        if ( new Date().getHours() < 9 ) {
            orderObject.time = "09:00 - 12:00";
        } else if ( new Date().getHours() < 12 ) {
            orderObject.time = "12:00 - 15:00";
        } else if ( new Date().getHours() < 15 ) {
            orderObject.time = "15:00 - 18:00";
        } else if ( new Date().getHours() < 18 ) {
            orderObject.time = "18:00 - 21:00";
        }
        setOrderObject( { ...orderObject } );
        document.querySelector( ".loader-container" ).style.display = "none";
    }

    async function addOrder ( event ) {
        messageApi.open( {
            type: 'loading',
            content: 'Placing Order..',
            duration: 0,
            style: {
                marginTop: "6rem"
            }
        } );
        let orderIdDoc = await getDoc( doc( firestore, "order_id", "order_id_doc" ) );
        let prefix = orderIdDoc.data().prefix;
        let count = orderIdDoc.data().order_count;
        let full_count = "000000";

        let fullCountLength = 6 - count.toString().length;
        let order_id = prefix + full_count.substr( 0, fullCountLength ) + count.toString();

        let cart_items_array = [];
        let isFiveDay = false;
        let cartDocs = await getDocs( collection( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders" ) );
        cartDocs.forEach( async ( element ) => {
            if ( element.data().service === "Dry Clean" ) {
                isFiveDay = true;
            }
            cart_items_array.push( element.data() );
            await deleteDoc( doc( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders", element.id ) );
        } )

        let addedDoc = await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/user_orders" ), {
            cart_items: JSON.stringify( cart_items_array ),
            delivery_charge: parseFloat( orderObject.deliveryCharge ),
            delivery_tip: orderObject.tip.toString(),
            delivery_within: orderObject.deliveryHours,
            discount: 0,
            express_delivery: parseFloat( orderObject.expressDeliveryCharge ),
            order_id: order_id,
            order_time: new Date(),
            order_total: ( parseFloat( total ) + parseFloat( orderObject.expressDeliveryCharge ) ),
            pickup_date: orderObject.day === "Today" ? new Date( new Date().setHours( 0, 0, 0, 0 ) ) : new Date( new Date().setDate( new Date().getDate() + 1 ) ),
            pincode: currentUser.pincode,
            status: "pending",
            timeslot: orderObject.time,
            user_id: auth.currentUser.uid,
            source: "website",
            address: currentUser.address
        } );

        await addDoc( collection( firestore, "orders_temp/upcoming_orders_id/upcoming_orders" ), {
            address: currentUser.address,
            cart_items: JSON.stringify( cart_items_array ),
            delivery_charge: parseFloat( orderObject.deliveryCharge ),
            delivery_tip: orderObject.tip.toString(),
            delivery_within: orderObject.deliveryHours,
            comments: orderObject.comment ?? "",
            discount: 0,
            isFiveDay: isFiveDay,
            name: currentUser.name,
            phone: currentUser.mobile,
            express_delivery: parseFloat( orderObject.expressDeliveryCharge ),
            order_id: order_id,
            order_time: new Date(),
            order_total: ( parseFloat( total ) + parseFloat( orderObject.expressDeliveryCharge ) ),
            pickup_date: orderObject.day === "Today" ? new Date( new Date().setHours( 0, 0, 0, 0 ) ) : new Date( new Date().setDate( new Date().getDate() + 1 ) ),
            pincode: currentUser.pincode,
            status: "pending",
            timeslot: orderObject.time,
            order_doc: addedDoc.id,
            user_id: auth.currentUser.uid,
            source: "website"
        } );

        await updateDoc( doc( firestore, "order_id", "order_id_doc" ), {
            order_count: count + 1
        } )
        await updateDoc( doc( firestore, "users", auth.currentUser.uid ), {
            last_order_date: new Date()
        } )
        messageApi.destroy();
        messageApi.success( 'Order Placed.' );
        setTimeout( ( element ) => {
            window.location.href = "/orders"
        }, 1000 );
    }

    // function myPosition ( position ) {
    //     let latitude = position.coords.latitude;
    //     let longitude = position.coords.longitude;

    //     Geocode.fromLatLng( latitude, longitude )
    //     .then( ( response ) => console.log( response ) )
    //     .catch((error) => console.error(error));
    // }

    useEffect( () => {
        document.title = "Laundry Buddy - Check Out";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), async ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        let cartDocs = await getDocs( collection( firestore, "users/" + user.uid + "/cart_items/all_orders_id/all_orders" ) );
                        if ( cartDocs.docs.length !== 0 ) {
                            onload( user );
                            setCurrentUser( snapshot.data() );
                        } else {
                            window.location.href = "/";
                        }
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                window.location.href = "/login";
            }
        } )
        document.querySelector( ".loader-container" ).style.display = "flex";
        window.scrollTo( 0, 0 );
    }, [] )

    return (
        <div className='place-order-container'>
            {contextHolder}
            <Toast style={{ position: "fixed", top: "1rem", zIndex: "111111" }} position="top-center" className='rounded me-2' onClose={() => setShow( false )} show={show}>
                <Toast.Header style={{ backgroundColor: "#117381", color: "white" }}>
                    <img
                        src={require( "../../images/logo.webp" )}
                        className="rounded me-2"
                        alt=""
                        height={30}
                    />
                    <strong className="me-auto">Service Error</strong>
                </Toast.Header>
                <Toast.Body style={{ backgroundColor: "#97C5C9", color: "white" }}>The following slot has been closed. Kindly book some other slot.</Toast.Body>
            </Toast>
            <Toast style={{ position: "fixed", top: "1rem", zIndex: "111111" }} position="top-center" className='rounded me-2' onClose={() => setShow2( false )} show={show2}>
                <Toast.Header style={{ backgroundColor: "#117381", color: "white" }}>
                    <img
                        src={require( "../../images/logo.webp" )}
                        className="rounded me-2"
                        alt=""
                        height={30}
                    />
                    <strong className="me-auto">Service Error</strong>
                </Toast.Header>
                <Toast.Body style={{ backgroundColor: "#97C5C9", color: "white" }}>All the slots for today has been closed. Kindly Book a slot for Tomorrow.</Toast.Body>
            </Toast>
            <div className='place-order-inner-container'>
                <div>
                    <img src={require( "../../images/registration-image-2.webp" )} width={"80%"} alt="" className='laptop' />
                    <img src={require( "../../images/registration-image-mobile.webp" )} width={"80%"} alt="" className='mobile' />
                </div>
                <div className='place-order-content-container'>
                    <h1>Place Order</h1>
                    <h5>Choose Your Delivery Method</h5>
                    <div className='delivery-type-selection'>
                        <div>
                            <Button className={orderObject.deliveryType === "Express" ? "active" : ""} onClick={event => {
                                orderObject.deliveryType = "Express";
                                orderObject.expressDeliveryCharge = total;
                                orderObject.deliveryHours = "24 hrs";
                                setOrderObject( { ...orderObject } );
                            }}>
                                Express Delivery
                            </Button>
                            <div>
                                Expect Delivery Within 24 Hours <Tooltip title=" x2 Billing Order Amount">
                                    <InfoCircleTwoTone style={{ cursor: "pointer" }} />
                                </Tooltip>
                            </div>
                        </div>
                        <div>
                            <Button className={orderObject.deliveryType === "Regular" ? "active" : ""} onClick={event => {
                                orderObject.deliveryType = "Regular";
                                orderObject.expressDeliveryCharge = 0;
                                orderObject.deliveryHours = "48-72 hrs";
                                setOrderObject( { ...orderObject } );
                            }}>
                                Regular Delivery
                            </Button>
                            <div>
                                Expect Delivery Within 3 - 5 Days
                            </div>
                        </div>
                    </div>
                    <h5>Date</h5>
                    <div style={{ flexDirection: "row" }}>
                        <Button className={orderObject.day === "Today" ? "active" : ""} onClick={event => {
                            orderObject.day = "Today";
                            if ( new Date().getHours() < 9 ) {
                                orderObject.time = "09:00 - 12:00";
                            } else if ( new Date().getHours() < 12 ) {
                                orderObject.time = "12:00 - 15:00";
                            } else if ( new Date().getHours() < 15 ) {
                                orderObject.time = "15:00 - 18:00";
                            } else if ( new Date().getHours() < 18 ) {
                                orderObject.time = "18:00 - 21:00";
                            }
                            setOrderObject( { ...orderObject } );
                        }} style={{ fontSize: "15px", padding: "0.2rem 1.5rem" }} disabled={new Date().getHours() >= 18 ? true : false}>
                            Today
                        </Button>
                        <Button className={orderObject.day === "Tomorrow" ? "active" : ""} onClick={event => {
                            orderObject.day = "Tomorrow";
                            orderObject.time = "09:00 - 12:00";
                            setOrderObject( { ...orderObject } );
                        }} style={{ fontSize: "15px", padding: "0.2rem 1.5rem" }}>
                            Tomorrow
                        </Button>
                    </div>
                    <h5>Drop Time Slot</h5>
                    <div>
                        <Button className={orderObject.time === "09:00 - 12:00" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, time: "09:00 - 12:00" } )} disabled={orderObject.day === "Today" && new Date().getHours() >= 9}>
                            9:00 AM - 12:00 PM
                        </Button>
                        <Button className={orderObject.time === "12:00 - 15:00" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, time: "12:00 - 15:00" } )} disabled={orderObject.day === "Today" && new Date().getHours() >= 12}>
                            12:00 PM - 3:00 PM
                        </Button>
                        <Button className={orderObject.time === "15:00 - 18:00" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, time: "15:00 - 18:00" } )} disabled={orderObject.day === "Today" && new Date().getHours() >= 15}>
                            3:00 PM - 6:00 PM
                        </Button>
                        <Button className={orderObject.time === "18:00 - 21:00" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, time: "18:00 - 21:00" } )} disabled={orderObject.day === "Today" && new Date().getHours() >= 18}>
                            6:00 PM - 9:00 PM
                        </Button>
                    </div>
                    <textarea className='delivery-instruction' placeholder='Write Your Instructions' onChange={event => {
                        setOrderObject( { ...orderObject, comment: event.target.value } );
                    }}></textarea>
                    <h5>Tip Your Delivery Partner</h5>
                    <h6>Appreciate your Delivery partner by leaving them a tip. 100% of the tip goes to your Delivery Partner</h6>
                    <div>
                        <Button className={orderObject.tip === "10" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "10" } )}>
                            Rs. 10
                        </Button>
                        <Button className={orderObject.tip === "15" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "15" } )}>
                            Rs. 15
                        </Button>
                        <Button className={orderObject.tip === "20" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "20" } )}>
                            Rs. 20
                        </Button>
                        <Button className={orderObject.tip === "25" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "25" } )}>
                            Rs. 25
                        </Button>
                        <Button className={orderObject.tip === "30" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "30" } )}>
                            Rs. 30
                        </Button>
                        <Button className={orderObject.tip === "35" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "35" } )}>
                            Rs. 35
                        </Button>
                        <Button className={orderObject.tip === "50" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "50" } )}>
                            Rs. 50
                        </Button>
                        <Button className={orderObject.tip === "75" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "75" } )}>
                            Rs. 75
                        </Button>
                        <Button className={orderObject.tip === "100" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "100" } )}>
                            Rs. 100
                        </Button>
                        <Button className={orderObject.tip === "150" ? "active" : ""} onClick={event => setOrderObject( { ...orderObject, tip: "150" } )}>
                            Rs. 150
                        </Button>
                    </div>
                    <Button onClick={event => addOrder( event )}>Schedule Free Pick Up</Button>
                </div>
            </div>
        </div >
    )
}

export default PlaceOrder